export default "__VITE_ASSET__Cu178$V7__"